import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngTinyMce } from '../../inputs';

@Component({
  selector: 'ing-tiny-mce',
  templateUrl: './tiny-mce.component.html',
  styleUrls: ['./tiny-mce.component.scss']
})
export class TinyMceComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngTinyMce;

  constructor() { }

  ngOnInit() {
    this.input.controlType = 'ing-tinymce';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/tiny-mce/tiny-mce.component.ts